
import Base from "../../../components/base/Base.vue";
import { Options } from "vue-class-component";
import ProfileUser from "../../../components/profileUser/ProfileUser.vue";
@Options({
  components: {
    ProfileUser
  }
})
export default class Profile extends Base {}
